import { objectToParam } from "../../libs/utils";
import axios from "../api";

export async function getCrewMembers(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("crew-members?" + parameters);
  return data;
}

export async function getMyCrewMembers(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("current-user/crew-members?" + parameters);
  return data;
}

export async function getCrewMember(id) {
  const { data } = await axios.get(
    "crew-members/" +
      id +
      "?include=user,profile,profile.accesses,crew-member-accesses,documents"
  );
  return data;
}

export async function createCrewMember(values) {
  const { data } = await axios.post("crew-members", values);
  return data;
}

export async function copyCrewMember(values) {
  console.debug("copyCrewMember", values);
  const { data } = await axios.post("copy-crew-member", values);
  return data;
}

export async function updateCrewMember(id, values) {
  const { data } = await axios.patch("crew-members/" + id, values);
  return data;
}

export async function deleteCrewMember(id) {
  const { data } = await axios.delete("crew-members/" + id);
  return data;
}

export async function getCrewMemberAccesses(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/crew-members/${id}/accesses?${parameters}`
  );
  return data;
}

export async function getCrewMemberTransits(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/crew-members/${id}/transits?${parameters}`
  );
  return data;
}

export async function addCrewMemberAccess(id, values) {
  const { data } = await axios.post(`/crew-members/${id}/accesses`, values);
  return data;
}

export async function deleteCrewMemberAccess(id, values) {
  const { data } = await axios.delete(`/crew-members/${id}/accesses`, {
    params: values
  });
  return data;
}

export async function addFileToCrewMember(id, values) {
  const { data } = await axios.post(`/crew-members/${id}/documents`, values);
  return data;
}

export async function removeFileFromCrewMember(id, docId) {
  const { data } = await axios.delete(`/crew-members/${id}/documents/${docId}`);
  return data;
}

export async function sendCrewMemberVouchers(id) {
  const { data } = await axios.post(`/crew-members/${id}/send-vouchers`);
  return data;
}
